import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Category, LoggerService, Occ, OccEndpointsService, normalizeHttpError } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CategoryAdapter } from './category.adapter';

@Injectable({
  providedIn: 'root',
})
export class OccCategoryAdapter implements CategoryAdapter {
  protected logger = inject(LoggerService);

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService
  ) {}

  load(catalogId: string, catalogVersionId: string, categoryId: string): Observable<Category> {
    const url = this.occEndpoints.buildUrl('category', {
      urlParams: { catalogId, catalogVersionId, categoryId },
    });
    return this.http
      .get<Occ.Category>(url)
      .pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }
}
